import React from 'react';

const Weighbridge = () => {
  return <div>Weighbridge</div>;
};

export default Weighbridge;
